import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import { AsyncResult, fromResult, Loaded, Loading } from 'Core/models/Async';
import {
  changeEmail,
  changevalidity,
  checkSecurityQuesValidity,
  getSecurityQues,
  recoverUsername,
  UserEmailRecoveryAddress,
  UsernameRecoveryActionTypes,
} from 'Users/ducks/userRecovery';
import axios from 'Shared/utilities/axiosInstance';
import { changeSecurityQuestionsForUserNameRecovery } from 'Users/ducks/userAccount';
import { SecurityQuestionByUserNamePayload } from 'Users/models/SecurityQuestionByUserNamePayload';
import { UnvalidatedEmail } from 'Core/models/Email';
import { UserUsernameApi } from 'Users/api';
import axiosInstance from 'Shared/utilities/axiosInstance';
import { handleResponse } from 'Shared/utilities/fetchHelpers';
import { pipe } from 'fp-ts/lib/pipeable';
import * as E from 'fp-ts/lib/Either';

const UsernameRecoveryApi = new UserUsernameApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

function* recoverUsernameApi(action: ReturnType<typeof recoverUsername>) {
  yield put(changeEmail(UserEmailRecoveryAddress.email(new Loading())));

  const recoverUsernameApiCall = () => {
    const ADDRESS_ROOT_URL: string = `api/user/v1/login/forgotUserId/ALLBA`;
    return axios
      .post(`${ADDRESS_ROOT_URL}`,action.payload.data["Data"]).then(handleResponse);
  };

  const resp: AsyncResult<SecurityQuestionByUserNamePayload> = yield call(recoverUsernameApiCall);

  yield pipe(
    resp,
    E.map(fromResult),
    E.fold(
      (value) => updateChanges(value, action.payload.email["Data"]),
      (value) => updateChanges(value)
    )
  );
}

function* updateChanges(res: any, email: any = null) {
  if(res.Data) {
    yield put(checkSecurityQuesValidity(res["Data"]["attemptsRemainingNbr"]))
    yield put(changeEmail(UserEmailRecoveryAddress.recoveryEmailSent(fromResult({}))))
  } else {
    yield put(checkSecurityQuesValidity(res["errorDetails"]["attemptsRemainingNbr"]));
    yield put(changeEmail(UserEmailRecoveryAddress.showSecurityQues(fromResult(email))))
  }
  
}

function* getSecurityQuesOrSendEmailApi(action: ReturnType<typeof getSecurityQues>) {
  yield put(changeEmail(UserEmailRecoveryAddress.email(new Loading())));

  const getSecurityQuesApiCall = (email: string) => {
    const ADDRESS_ROOT_URL: string = `api/user/v1/login/forgotUserId/${email}`;
    return axios
      .request({
        method: "get",
        url: `${ADDRESS_ROOT_URL}`, 
      }).then(handleResponse);
  };

  const resp: AsyncResult<SecurityQuestionByUserNamePayload> = yield call(getSecurityQuesApiCall, action.payload.email.address);

  yield pipe(
    resp,
    E.map(fromResult),
    E.fold(
      () => updateValue(null, action.payload.email.address),
      (value) => updateValue(value, action.payload.email.address)
    )
  );
}

function* updateValue(value: any, email: string) {
  if(value && value.Data.identity.uuid) {
    yield put(changeSecurityQuestionsForUserNameRecovery(new Loaded(value.Data)));
    yield put(changevalidity(true))
    yield put(changeEmail(UserEmailRecoveryAddress.showSecurityQues(fromResult(email))));
  } 
  else {
    yield put(changevalidity(false));
    yield put(changeEmail(UserEmailRecoveryAddress.email(fromResult(new UnvalidatedEmail(email)))));
  }
}


function* recoverUsernameSaga() {
  yield takeLatest(UsernameRecoveryActionTypes.RECOVER_USERNAME, recoverUsernameApi);
}

function* getSecurityQuesSaga() {
  yield takeLatest(UsernameRecoveryActionTypes.SECURITY_QUES, getSecurityQuesOrSendEmailApi);
}

export default function*() {
  return yield all([recoverUsernameSaga(), getSecurityQuesSaga()]);
}
